import { IComponentConfig } from "@/app/@types/base-component";
import {
    createMountedTransomPatchConfig,
    createTransomCutHoles,
    createTransomPivodPatchConfig,
} from "../../configs/hardwares.config";

import { Hardware } from "../../entities/hardware";
import { CreateManyStrategy } from "../base/creation.strategy";

export class SingleSwingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const SINGLE_SWING_DOOR_HARDWARES_CONFIG: IComponentConfig[] = [
            createMountedTransomPatchConfig().build(),
            createTransomPivodPatchConfig().build(),
            createTransomCutHoles().build(),
        ];
        super(SINGLE_SWING_DOOR_HARDWARES_CONFIG, Hardware);
    }
}

export class DoubleSwingDoorHardwareStrategy extends CreateManyStrategy {
    constructor() {
        const DOUBLE_SWING_DOOR_HARDWARES_CONFIG: IComponentConfig[] = [
            createMountedTransomPatchConfig().qty(2).build(),
            createTransomPivodPatchConfig().qty(2).build(),
            createTransomCutHoles().build(),
        ];
        super(DOUBLE_SWING_DOOR_HARDWARES_CONFIG, Hardware);
    }
}
